var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.591797,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.591797,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#ECECEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5698_116646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7581 6.66667H10.4248L8.75814 8.66667H6.75814C6.40452 8.66667 6.06538 8.80714 5.81533 9.05719C5.56528 9.30724 5.4248 9.64638 5.4248 10V16C5.4248 16.3536 5.56528 16.6928 5.81533 16.9428C6.06538 17.1929 6.40452 17.3333 6.75814 17.3333H17.4248C17.7784 17.3333 18.1176 17.1929 18.3676 16.9428C18.6177 16.6928 18.7581 16.3536 18.7581 16V10C18.7581 9.64638 18.6177 9.30724 18.3676 9.05719C18.1176 8.80714 17.7784 8.66667 17.4248 8.66667H15.4248L13.7581 6.66667Z",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0915 14.6667C13.196 14.6667 14.0915 13.7712 14.0915 12.6667C14.0915 11.5621 13.196 10.6667 12.0915 10.6667C10.9869 10.6667 10.0915 11.5621 10.0915 12.6667C10.0915 13.7712 10.9869 14.6667 12.0915 14.6667Z",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5698_116646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4.0918 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoMarker);
export default __webpack_public_path__ + "static/media/photo-marker.667c914634bc711e72d2bab42f7c16f6.svg";
export { ForwardRef as ReactComponent };